import { createAction, props } from '@ngrx/store';
import { Customer } from '@fc-core';

export const retrieveCurrentCustomerAction = createAction(
  '[CurrentCustomer] Retrieve current customer from the api',
);

export const loadCurrentCustomerActionSuccess = createAction(
  '[CurrentCustomer] Load Current customer success',
  props<{ customer: Customer }>(),
);

export const loadCurrentCustomerActionError = createAction(
  '[CurrentCustomer] Load Current customer error',
  props<{ err?: any }>(),
);

export const updateCurrentCustomerAction = createAction(
  '[CurrentCustomer] Update Current Customer',
  props<{ customer: Customer }>(),
);

export const updateCurrentCustomerActionSuccess = createAction(
  '[CurrentCustomer] Update Current Customer Success',
  props<{ customer: Customer }>(),
);

export const updateCurrentCustomerActionError = createAction(
  '[CurrentCustomer] Update Current Customer Error',
  props<{ err?: any }>(),
);
